export const SHOOT_FETCHING = "SHOOT_FETCHING";
export const SHOOT_FETCHED = "SHOOT_FETCHED";
export const SHOOT_FETCH_FAILED = "SHOOT_FETCH_FAILED";

export const SHOOTS_CANCEL_EDIT = "SHOOTS_CANCEL_EDIT";

//get shoots
export const SHOOTS_GET_ALL = "SHOOTS_GET_ALL";
export const SHOOTS_GET_ALL_SUCCESS = "SHOOTS_GET_ALL_SUCCESS";
export const SHOOTS_GET_SHOTS = "SHOOTS_GET_SHOTS";
export const SHOOTS_GET_SHOTS_SUCCESS = "SHOOTS_GET_SHOTS_SUCCESS";
//save shoots
export const SHOOTS_SAVE_SHOOT = "SHOOTS_SAVE_SHOOT";
//edit shoots
export const SHOOTS_GET_ONE = "SHOOTS_GET_ONE";
export const SHOOTS_GET_ONE_SUCCESS = "SHOOTS_GET_ONE_SUCCESS";
//delete shoots
export const SHOOTS_DELETE_SHOOT = "SHOOTS_DELETE_SHOOT";
export const SHOOTS_START = "SHOOTS_START";
export const SHOOTS_START_DIALOG_OPEN = "SHOOTS_START_DIALOG_OPEN";
export const SHOOTS_START_DIALOG_CLOSE = "SHOOTS_START_DIALOG_CLOSE";
export const SHOOTS_START_SUCCESS = "SHOOTS_START_SUCCESS";

//edit the photo shots
export const SHOOTS_EDIT_PHOTO_SHOTS = "SHOOTS_EDIT_PHOTO_SHOTS";
export const SHOOTS_EDIT_VIDEO_SHOTS = "SHOOTS_EDIT_VIDEO_SHOTS";

//edit the video shots
export const SHOOTS_SAVE_PHOTO_SHOTS = "SHOOTS_SAVE_PHOTO_SHOTS";
export const SHOOTS_SAVE_VIDEO_SHOTS = "SHOOTS_SAVE_VIDEO_SHOTS";

//mark shots in shoots as checked
export const SHOOTS_PHOTO_SHOTS_CHECKED = "SHOOTS_PHOTO_SHOTS_CHECKED";
export const SHOOTS_VIDEO_SHOTS_CHECKED = "SHOOTS_VIDEO_SHOTS_CHECKED";

//remove shots from the shoot(draft)
export const SHOOTS_REMOVE_SHOTS = "SHOOTS_REMOVE_SHOTS";
export const SHOOTS_REMOVE_SHOTS_SUCCESS = "SHOOTS_REMOVE_SHOTS_SUCCESS";

export const SHOOTS_INITIATE_ADD_SHOTS = "SHOOTS_INITIATE_ADD_SHOTS";

export const SHOOTS_HANDLE_CHECKBOX = "SHOOTS_HANDLE_CHECKBOX";
export const SHOOTS_HANDLE_CHECKBOX_ALL = "SHOOTS_HANDLE_CHECKBOX_ALL";

//approving shots
export const SHOOTS_CHECK_APPROVE = "SHOOTS_CHECK_APPROVE";
export const SHOOTS_CHECK_APPROVE_SUCCESS = "SHOOTS_CHECK_APPROVE_SUCCESS";
export const SHOOTS_CHECK_REJECT = "SHOOTS_CHECK_REJECT";
export const SHOOTS_CHECK_REJECT_SUCCESS = "SHOOTS_CHECK_REJECT_SUCCESS";

export const SHOOTS_MARK_SHOOT_COMPLETE = "SHOOTS_MARK_SHOOT_COMPLETE";
export const SHOOTS_MARK_SHOOT_COMPLETE_SUCCESS = "SHOOTS_MARK_SHOOT_COMPLETE_SUCCESS";

export const SHOOT_GET_STATUS = "SHOOT_GET_STATUS";
export const SHOOT_GET_STATUS_SUCCESS = "SHOOT_GET_STATUS_SUCCESS";

export const SHOOT_UPDATE_SHOT_PRIORITY = "SHOOT_UPDATE_SHOT_PRIORITY";
export const SHOOT_UPDATE_SHOT_PRIORITY_SUCCESS = "SHOOT_UPDATE_SHOT_PRIORITY_SUCCESS";

//questions
export const SHOOT_GET_QUESTION = "SHOOT_GET_QUESTION";
export const SHOOT_GET_QUESTION_SUCCESS = "SHOOT_GET_QUESTION_SUCCESS";
export const SHOOT_QUESTION_HANDLE_CHECKBOX = "SHOOT_QUESTION_HANDLE_CHECKBOX";
export const SHOOT_QUESTION_SET_SELECTEDQUESTIONS = "SHOOT_QUESTION_SET_SELECTEDQUESTIONS";
export const SHOOT_QUESTION_RESET_SELECTEDQUESTIONS = "SHOOT_QUESTION_RESET_SELECTEDQUESTIONS";
export const SHOOT_QUESTION_REMOVE = "SHOOT_QUESTION_REMOVE";
export const SHOOT_QUESTION_REMOVE_SUCCESS = "SHOOT_QUESTION_REMOVE_SUCCESS";

//packages
export const SHOOT_GET_PACKAGES = "SHOOT_GET_PACKAGES";
export const SHOOT_GET_PACKAGES_SUCCESS = "SHOOT_GET_PACKAGES_SUCCESS";
